import axios from 'axios'
import type { AxiosInstance } from 'axios'
import { API_CONFIG } from '@/config/api.config'
import { applyAuthInterceptor } from './interceptors/auth.interceptor'
import { applyErrorInterceptor } from './interceptors/error.interceptor'

function createHttpClient(): AxiosInstance {
  const instance = axios.create({
    baseURL: API_CONFIG.baseUrl,
    timeout: API_CONFIG.timeout,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  })

  applyAuthInterceptor(instance)
  applyErrorInterceptor(instance)

  return instance
}

export const httpClient = createHttpClient()
